import script from "./PropertyCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyCard.vue?vue&type=script&setup=true&lang=js"

import "./PropertyCard.vue?vue&type=style&index=0&id=75880868&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75880868"]])

export default __exports__